<template>
  <tr>
    <td>{{ item.clientTitle}}</td>
    <td>{{ item.serviceTitle }}</td>
    <td>
        <v-tooltip bottom>
          <span slot="activator" :class="item.contractorType">
            {{ item.contractorTitle }}
          </span>
          <span>
            {{ item.contractorFrom }}
          </span>
        </v-tooltip>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'contractor-item-detail',
  props: {
    item: {
      type: Object
    },
  },
}
</script>

<style scoped>
  .client-service {
    color: black;
  }

  .service {
    color: blue
  }

  .client {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ContractorItemDetail.vue